import { InventoryAdjustment } from '../../inventory/InventoryAdjustment'
import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

@InputType()
export class AdjustMultipleProductInventoryServiceArgs extends ActionArgs {
  @Field(() => [InventoryAdjustment])
  items: InventoryAdjustment[]

  @Field(() => String)
  transactionType: string

  @Field(() => String)
  transactionRef: string

  @Field(() => String)
  remarks?: string

  @Field(() => [String], { nullable: true })
  tags?: string[]
}

export interface IAdjustMultipleProductInventoryService extends IAction<
  InventoryAdjustment[],
  AdjustMultipleProductInventoryServiceArgs
> {}
